// Set webpack public asset url

import VacationController from "./controllers/vacation-controller";
import initTomSelect from './utilities/select';

window.__webpack_public_path__ = getMeta('theme-url');

window.axios = require('axios');

import { Application } from '@hotwired/stimulus';
import AppController from "./controllers/app-controller";
import AxiosFormController from './controllers/axios-form-controller';
import BlockAsyncController from './controllers/block-async-controller';
import CookieBarController from './controllers/cookie-bar-controller';
import DatePickerController from './controllers/date-picker-controller';
import ExpandableController from './controllers/expandable-controller';
import LeafletController from './controllers/leaflet-maps-controller';
import ModalController from './controllers/modal-controller';
import MoreController from './controllers/more-controller';
import SliderController from './controllers/slider-controller';
import TabController from './controllers/tab-controller';
import GalleryController from "./controllers/gallery-controller";
import VideoPlayerController from "./controllers/video-player-controller";
import SelectController from "./controllers/select-controller";
import FaqController from "./controllers/faq-controller";
import NewsController from "./controllers/news-controller";
import TrainersController from "./controllers/trainers-controller";
import WorkoutsController from "./controllers/workouts-controller";
import CategoryFilterController from "./controllers/category-filter-controller";
import TooltipController from "./controllers/tooltip-controller";
import SchedulesController from "./controllers/schedules-controller";
import CheckoutController from "./controllers/checkout-controller";
import CheckoutDebtController from "./controllers/checkout-debt-controller";
import HeaderController from "./controllers/header-controller";
import PricesTableController from "./controllers/prices-table-controller";
import PricesTableV2Controller from "./controllers/prices-table-v2-controller";
import DropdownController from "./controllers/dropdown-controller";
import ProfileInfoController from "./controllers/profile-info-controller";
import ProfileController from "./controllers/profile-controller";
import CartPopupController from "./controllers/cart-popup-controller";
import FileController from "./controllers/file-controller";
import CountdownController from "./controllers/countdown-controller";
import AccordionController from "./controllers/accordion-controller";
import DomModalController from "./controllers/dom-modal-controller";
import CartSummaryController from "./controllers/cart-summary-controller";
import TomSelectController from "./controllers/tom-select-controller";
import DiscountController from "./controllers/discount-controller";
import ParcelBoxSelectController from "./controllers/parcel-box-select-controller";
import PhoneController from "./controllers/phone-controller";
import FullPageLoaderController from "./controllers/fullpage-loader-controller";
import ClipboardController from "./controllers/clipboard-controller";
import HorizontalWheelController from "./controllers/horizontal-wheel-controller";
import CoachController from './controllers/coach-controller';
import MembershipTakeoverController from "./controllers/membership-takeover-controller";
import ReservationsController from "./controllers/reservations-controller";
import CourtPickerController from "./controllers/court-picker-controller";
import GoogleReviewsController from "./controllers/google-reviews-controller";
import ContractChangeController from "./controllers/contract-change-controller";
import CoachAutocompleteController from "./controllers/coach-autocomplete-controller";
import MultistepClubDropdownController from "./controllers/multistep-club-dropdown-controller";
import CheckoutPriceController from "./controllers/checkout-price-controller";
import CouponController from "./controllers/coupon-controller";
import WorkoutSurveyController from "./controllers/workout-survey-controller";
import CelebrationController from "./controllers/celebration-controller";
import SendInfoVerificationController from "./controllers/send-info-verification-controller";
import CalendarController from "./controllers/calendar-controller";
import SwitchController from "./controllers/switch-controller";
import HeaderCountdownController from "./controllers/header-countdown-controller";
import ModalConsentController from "./controllers/modal-consent-controller";
import VirtualAssistantTriggerController from "./controllers/virtual-assistant-trigger-controller";
import CallButtonController from "./controllers/call-button-controller";
import ForgotPasswordController from "./controllers/forgot-password-controller";

// app loyalty program
import LoyaltyProgressBarController from "./controllers/app/loyalty-progress-bar-controller";
import AppModalController from "./controllers/app/app-modal-controller";
import ShareModalController from "./controllers/app/share-modal-controller";
import MultistepModalController from "./controllers/app/multistep-modal-controller";
import NoticeModalController from "./controllers/app/notice-modal-controller";
import LoyaltyItemController from "./controllers/app/loyalty-item-controller";
import LoyaltyGameController from "./controllers/app/loyalty-game-controller";

// modules
import registerDashboard from '../../template-parts/dashboard/dashboard';

import { getMeta, onDomReady} from './helpers';

const application = Application.start();

// modules
registerDashboard(application);

window.Stimulus = application;

application.register('app', AppController);
application.register('block-async', BlockAsyncController);
application.register('axios-form', AxiosFormController);
application.register('cookie-bar', CookieBarController);
application.register('date-picker', DatePickerController);
application.register('modal', ModalController);
application.register('dom-modal', DomModalController);
application.register('tab', TabController);
application.register('slider', SliderController);
application.register('expandable', ExpandableController);
application.register('leaflet', LeafletController);
application.register('slider', SliderController);
application.register('gallery', GalleryController);
application.register('video-player', VideoPlayerController);
application.register('select', SelectController);
application.register('dropdown', DropdownController);
application.register('faq', FaqController);
application.register('news', NewsController);
application.register('trainers', TrainersController);
application.register('workouts', WorkoutsController);
application.register('category-filter', CategoryFilterController);
application.register('tooltip', TooltipController);
application.register('more', MoreController);
application.register('schedules', SchedulesController);
application.register('checkout', CheckoutController);
application.register('header', HeaderController);
application.register('prices-table', PricesTableController);
application.register('prices-table-v2', PricesTableV2Controller);
application.register('profile-info', ProfileInfoController);
application.register('profile', ProfileController);
application.register('cart-popup', CartPopupController);
application.register('checkout-debt', CheckoutDebtController);
application.register('file', FileController);
application.register('countdown', CountdownController);
application.register('vacation', VacationController);
application.register('accordion', AccordionController);
application.register('cart-summary', CartSummaryController);
application.register('tom-select', TomSelectController);
application.register('discount', DiscountController);
application.register('parcel-box-select', ParcelBoxSelectController);
application.register('phone', PhoneController);
application.register('fullpage-loader', FullPageLoaderController);
application.register('clipboard', ClipboardController);
application.register('hwheel', HorizontalWheelController);
application.register('coach', CoachController);
application.register('membership-takeover', MembershipTakeoverController)
application.register('contract-change', ContractChangeController);
application.register('reservations', ReservationsController);
application.register('court-picker', CourtPickerController);
application.register('google-reviews', GoogleReviewsController);
application.register('coach-autocomplete', CoachAutocompleteController);
application.register('multistep-club-dropdown', MultistepClubDropdownController);
application.register('checkout-price', CheckoutPriceController);
application.register('coupon', CouponController);
application.register('workout-survey', WorkoutSurveyController);
application.register('celebration', CelebrationController);
application.register('send-info-verification', SendInfoVerificationController);
application.register('calendar', CalendarController);
application.register('multistep-modal', MultistepModalController);
application.register('loyalty-progress', LoyaltyProgressBarController);
application.register('app-modal', AppModalController);
application.register('share-modal', ShareModalController);
application.register('notice-modal', NoticeModalController);
application.register('loyalty-item', LoyaltyItemController);
application.register('loyalty-game', LoyaltyGameController);
application.register('switch', SwitchController)
application.register('header-countdown', HeaderCountdownController);
application.register('modal-consent', ModalConsentController);
application.register('virtual-assistant-trigger', VirtualAssistantTriggerController);
application.register('call-button', CallButtonController);
application.register('forgot-password', ForgotPasswordController);


import './navigation';

onDomReady(() => {
    //on dom ready
    initTomSelect();
});

function getApplication() {
    return application;
}

export {
    getApplication,
};
